/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DailyTaskProgressDto
 */
export interface DailyTaskProgressDto {
    /**
     * 
     * @type {number}
     * @memberof DailyTaskProgressDto
     */
    current: number;
    /**
     * 
     * @type {number}
     * @memberof DailyTaskProgressDto
     */
    target: number;
    /**
     * 
     * @type {string}
     * @memberof DailyTaskProgressDto
     */
    unit: string;
}

/**
 * Check if a given object implements the DailyTaskProgressDto interface.
 */
export function instanceOfDailyTaskProgressDto(value: object): value is DailyTaskProgressDto {
    if (!('current' in value) || value['current'] === undefined) return false;
    if (!('target' in value) || value['target'] === undefined) return false;
    if (!('unit' in value) || value['unit'] === undefined) return false;
    return true;
}

export function DailyTaskProgressDtoFromJSON(json: any): DailyTaskProgressDto {
    return DailyTaskProgressDtoFromJSONTyped(json, false);
}

export function DailyTaskProgressDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DailyTaskProgressDto {
    if (json == null) {
        return json;
    }
    return {
        
        'current': json['current'],
        'target': json['target'],
        'unit': json['unit'],
    };
}

export function DailyTaskProgressDtoToJSON(json: any): DailyTaskProgressDto {
    return DailyTaskProgressDtoToJSONTyped(json, false);
}

export function DailyTaskProgressDtoToJSONTyped(value?: DailyTaskProgressDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'current': value['current'],
        'target': value['target'],
        'unit': value['unit'],
    };
}

